import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomExceptionService } from 'src/app/errorHandlers/custom-exception.service';
import { usererrors } from 'src/app/errors/usererrors';
import { CustomerSite } from 'src/app/Models/CustomerSite';
import { PrequotesignoffService } from 'src/app/Services/prequotesignoff.service';
import { vcusEmailID, vCustomersite, vServiceLocations } from 'src/app/Validators/validation';
import { CommonUtilities } from 'src/assets/js/common-utilities';
import { KeyPress } from 'src/assets/js/KeyPress';
import * as XLSX from 'xlsx';
// import * as ace from "ace-builds";
import { CustomerSiteContact } from 'src/app/Models/Customersitecontact';
@Component({
  selector: 'app-c-prequotesignoff',
  templateUrl: './c-prequotesignoff.component.html',
  styleUrls: ['./c-prequotesignoff.component.css']
})
export class CPrequotesignoffComponent implements OnInit {
  _Tempsignform: FormGroup
  _Signoffform: FormGroup
  _ServiceLocationAndOperation_SpecialDelivery_Form: FormGroup
  _PrequoteSignoff: CustomerSite
  selectedtab: number = 0;
  displayBasic: boolean;
  _CustomerApprovedList: any[]
  customersiteCode: string
  customerCode: string
  _LastAddedDocumentsignoff: File
  _TempLastAddedDocumentinCustomer: File
  displaySuccessMSG: boolean = false;

  CusomersignoffFile: File[] = [];
  imageselect: string = ""
   disabledate: boolean = false
  _submittedimage: boolean = false
  _SLSpecialDeliverysubmitted: boolean = false
  ValidateSpecial: boolean = true
  selectedFiles: any;
  SpecialDeliveryList: any[] = [];
  _SpecialDelivery: any[]
  _TempSLPincodeLocation: any[]
  _SLFloorType: any[]
  TempSLpincodelocation: any[]
  disablePinLocation: boolean = true
  _ApprovalComment: any[];
  currentFile: File;
  arrayBuffer: any
  VolumeReferList: any[]
  _IsSpecialDelivery: any[]
  DisableSpecial: boolean = false
  _CustomerContactInvoiceform: FormGroup;
  _CustomerContactOutgoingform: FormGroup;
  Contactselectedtab: number = 0
  _submitted: boolean = false
  _SignOffOBJ: any
  _InvoiceConfigurations:any
  disableInvoice:boolean = true
  @ViewChild("editor", { static: true }) private editor: ElementRef<HTMLElement>;
  constructor(private utility: CommonUtilities, private _PrequotesignoffService: PrequotesignoffService, private _CustomExceptionService: CustomExceptionService,
    private fb: FormBuilder, private router: Router, public keypress: KeyPress,) {
      
     }

  ngOnInit(): void {
    this.utility.pageLoadScript();
    this._Signoffform = this.fb.group({
      cutoffdateforsignedcontract: [],
      prequotesignoffcomments: ['',vCustomersite],
      prequotesignedoffby: [],
      prequotesignedon: [],

      // tempcustomer:[],

      customercode: [],
      customersitecode: [],
      customersitename: [],
      credittypecode: [],
      credittypes: [],
      acquiredbycode: [],
      acquiredby: [],
      billingtocode: [],
      billingto: [],
      productname: [],
      producttypecode: [],
      producttype: [],
      gstin: [],
      gstStatuscode: [],
      gstStatus: [],
      validationbasedoncode: [],
      validationbasedon: [],
      idNumber: [],
      //client_id:[],
      // AadharOTPVerification:[],
      onBehalfOf: [],
      gstValidationstatuscode: [],
      gstValidationstatus: [],
      googlelocation: [],
      latitude: [],
      longitude: [],
      pickuplocationphotoURL: [],
      // pickuplocationphotoFORMFILE: [],
      pickuplocationintime: [],
      pickuplocationouttime: [],
      pickuplocationobservations: [],
      recordstatus: [],
      createdby: [],
      modifiedby: [],
      createdon: [],
      modifiedon: [],
      accountingyear: [],
      lstCustomerSiteAddress: [],
      lstCustomerSiteContact: [],
      customername: [],
      companytypecode: [],
      companytype: [],
      tallyid: [],
      pan: [],
      billingcyclecode: [],
      billingcycle: [],
      istransportercode: [],
      istransporter: [],
      prequotestatuscode: [],
      prequotestatus: [],
      recordstatuscode: [],
      comments: [],
      signedcontractdocumentURL: [],
      isspecialdelivery: ["MSC00012"],
      lrcopyrequired:[],
      invoiceconfiguration:[],
      gstapplicable:[false],
      joborderdate:[false],
      isewaybillmandatory:[true],
      waybilltotalamount:[false],
      waybillsplitupamount:[false],
      // cutoffdateforsignedcontract: [],
      // prequotesignoffcomments: [],
      // prequotesignedoffby: [],
      // prequotesignedon: [],
    });
    this._Tempsignform = this.fb.group({
      tempcustomersite: [],
      tempcustomer: []
    });
    this._CustomerContactInvoiceform = this.fb.group({
      contactid: [],
      customersitecode: [],
      contacttype: [],
      contactperson: ['', vCustomersite],
      designation: ['', vCustomersite],
      department: ['', vCustomersite],
      phoneno: [],
      mobileno: ['', vCustomersite],
      emailid: ['', vcusEmailID],
      faxno: [],
      contacttypecode: [],
      recordstatuscode: [],
      recordstatus: []
    });
    this._CustomerContactOutgoingform = this.fb.group({
      contactid: [],
      customersitecode: [],
      contacttype: [],
      contactperson: ['', vCustomersite],
      designation: ['', vCustomersite],
      department: ['', vCustomersite],
      phoneno: [],
      mobileno: ['', vCustomersite],
      emailid: ['', vcusEmailID],
      faxno: [],
      contacttypecode: [],
      recordstatuscode: [],
      recordstatus: []
    });
    this._ServiceLocationAndOperation_SpecialDelivery_Form = this.fb.group({
      SpecialDeliverytypecode: ['', vServiceLocations],
      ContactPerson: ['', vServiceLocations],
      MobileNo: ['', vServiceLocations],
      EmailID: ['', vcusEmailID],
      Address: ['', vServiceLocations],
      PinCode: ['', vServiceLocations],
      PincodeLocation: ['', vServiceLocations],
      Floor: ['', vServiceLocations],
    })
    // this._IsSpecialDelivery = [
    //   { metasubcode: '1', metasubdescription: 'yes' },
    //   { metasubcode: '2', metasubdescription: 'No' },
    // ]

    let today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();
    let day = today.getDate();
    //let nextMonth = (month === 11) ? 0 : month + 1;
    //let nextYear = (nextMonth === 0) ? year + 1 : year;
    let nextYear = new Date(year + 1, month, day);
    //this._Signoffform.controls['cutoffdateforsignedcontract'].setValue(nextYear);

    this._PrequotesignoffService.GetPrequoteSignOffInitializeDetails().subscribe((result) => {

      const resultJSON = JSON.parse(JSON.stringify(result));
      console.log(resultJSON);
      this._IsSpecialDelivery = resultJSON.lstSpecialdelivery
      this._SpecialDelivery = resultJSON.lstSpecialDeliveryType;
      this._TempSLPincodeLocation = resultJSON.lstPincodeLocation;
      this._SLFloorType = resultJSON.lstFloorType;
      this._InvoiceConfigurations = resultJSON.lstInvoiceConfiguration;
      // console.log("signoffpageload", resultJSON);

      this._CustomerApprovedList = resultJSON.lstCustomerSite
      this._Signoffform.controls['lrcopyrequired'].setValue('MSC00012');
    }, error => { this._CustomExceptionService.handleError(error) }
    );
  }
  GetSpecial(event) {
    console.log(event);

    if (event == "MSC00011") {
      this.DisableSpecial = true
    }
    else {
      this.DisableSpecial = false
    }
  }
  selectFile(event): void {
    this.selectedFiles = event.target.files;
    this.ValidateSpecial = false

    // this.selectedFiles = []
  }
  ClearSpecialDelivery() {
    this._SLSpecialDeliverysubmitted = false;
    this._ServiceLocationAndOperation_SpecialDelivery_Form.reset();
  }
  enterpincodeSL(event) {
    var PinCode = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("PinCode").value;
    if (PinCode.length == 6) {
      this.disablePinLocation = false
      this.TempSLpincodelocation = this._TempSLPincodeLocation.filter(f => f.pincode == PinCode);
    }
  }
  upload() {
    this.currentFile = this.selectedFiles.item(0);;
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.currentFile);
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
      var arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      this.VolumeReferList = XLSX.utils.sheet_to_json(worksheet, { raw: true })
      //this.selectedFiles  = [];    
      console.log(arraylist)
      this.SpecialDeliveryList = this.VolumeReferList
      for (var i = 0; i < this.VolumeReferList.length; i++) {
        this.SpecialDeliveryList[i].SpecialDeliverytypecode = this.VolumeReferList[i].SpecialDeliverytypecode
        this.SpecialDeliveryList[i].SpecialDeliverytype = this.VolumeReferList[i].SpecialDeliverytype
        this.SpecialDeliveryList[i].ContactPerson = this.VolumeReferList[i].ContactPerson
        this.SpecialDeliveryList[i].MobileNo = this.VolumeReferList[i].MobileNo
        this.SpecialDeliveryList[i].EmailID = this.VolumeReferList[i].EmailID
        this.SpecialDeliveryList[i].Address = this.VolumeReferList[i].Address
        this.SpecialDeliveryList[i].Floortype = this.VolumeReferList[i].Floortype
        this.SpecialDeliveryList[i].Floortypecode = this.VolumeReferList[i].Floortypecode
        this.SpecialDeliveryList[i].PinCode = this.VolumeReferList[i].PinCode
        this.SpecialDeliveryList[i].PincodeLocation = this.VolumeReferList[i].PincodeLocation
      }
    }
  }
  showBasicDialog() {
    this.displayBasic = true;
  }
  onRowSelectPopup(event: any) {
    this.displayBasic = false;
    var row = event.data;
    // var temp = "true"
    // this.CustomerCode = row.customercode || 0
    this._Tempsignform.controls['tempcustomersite'].setValue(row.customersitename);
    this._Tempsignform.controls['tempcustomer'].setValue(row.customername);
    this.customersiteCode = row.customersitecode
    this.customerCode = row.customercode

    this._PrequotesignoffService.GetPrequoteSignOffById(this.customersiteCode).subscribe((result) => {

      const resultJSON = JSON.parse(JSON.stringify(result));
      console.log("signoffid", resultJSON);

      this._ApprovalComment = resultJSON.lstApprovalComment;

      this._CustomerApprovedList = resultJSON.lstCustomerSite
    }, error => { this._CustomExceptionService.handleError(error) }
    );
  }
  AddSpecialDelivery() {
    this._SLSpecialDeliverysubmitted = true;
    /*if (this.addressRowIndex > -1) {
      this._ServiceLocationAndOperation_SpecialDelivery_Form[this.addressRowIndex] = this._ServiceLocationAndOperation_SpecialDelivery_Form.value;
      }
      else*/
    /*alert(this.SpecialDeliveryList.length);
    if(this.SpecialDeliveryList.length > 0){
  var SpecialDeliveryListTemp_:any={};
  //this.SpecialDeliveryList(this._ServiceLocationAndOperation_SpecialDelivery_Form);
  SpecialDeliveryListTemp_.SpecialDelivery = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("SpecialDelivery").value.metasubcode,
  SpecialDeliveryListTemp_.ContactPerson = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("ContactPerson").value,
  SpecialDeliveryListTemp_.MobileNo = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("MobileNo").value,
  SpecialDeliveryListTemp_.EmailID = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("EmailID").value,
  SpecialDeliveryListTemp_.Address = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("Address").value,
  SpecialDeliveryListTemp_.PinCode = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("PinCode").value,
  //SpecialDeliveryListTemp.PincodeLocation = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("PincodeLocation").value,

  SpecialDeliveryListTemp_.Floor = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("Floor").value.metasubcode,
  SpecialDeliveryListTemp_.PincodeLocation ="123";
  //SpecialDeliveryListTemp.SpecialDelivery = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("SpecialDelivery").value;
  this.SpecialDeliveryList.push(SpecialDeliveryListTemp_);
  /*this.SpecialDeliveryList.SpecialDelivery= this._ServiceLocationAndOperation_SpecialDelivery_Form.get("SpecialDelivery").value
  this.SpecialDeliveryList.ContactPerson= this.VolumeReferList[i].ContactPerson
  this.SpecialDeliveryList.MobileNo= this.VolumeReferList[i].MobileNo
  this.SpecialDeliveryList.EmailID= this.VolumeReferList[i].EmailID
  this.SpecialDeliveryList[i].Address= this.VolumeReferList[i].Address
  this.SpecialDeliveryList[i].Floor= this.VolumeReferList[i].Floor
  this.SpecialDeliveryList[i].PinCode= this.VolumeReferList[i].PinCode
  this.SpecialDeliveryList[i].PincodeLocation= this.VolumeReferList[i].PincodeLocation
    }
    else{*/
    if (this._ServiceLocationAndOperation_SpecialDelivery_Form.valid) {


      var SpecialDeliveryListTemp: any = {};

      /* PincodeLocation: any,
       Floor: any,
       PinCode: any,
       Address: any,
       EmailID: any,
       MobileNo: any,
       ContactPerson: any,
       SpecialDelivery: any;*/
      //this.SpecialDeliveryList(this._ServiceLocationAndOperation_SpecialDelivery_Form);
      var Taluk = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("PinCode").value
      var TalukName = (this._TempSLPincodeLocation.filter(f => f.pincode == Taluk)[0].taluk);
      var deliverytype = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("SpecialDeliverytypecode").value;
      var DeliverTypeName = (this._SpecialDelivery || []).filter(f => f.metasubcode == deliverytype)[0].metasubdescription;
      var Floortype = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("Floor").value
      var FloortypeName = (this._SLFloorType || []).filter(f => f.metasubcode == Floortype)[0].metasubdescription;


      SpecialDeliveryListTemp.SpecialDeliverytypecode = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("SpecialDeliverytypecode").value;
      SpecialDeliveryListTemp.SpecialDeliverytype = DeliverTypeName
      SpecialDeliveryListTemp.contactPerson = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("ContactPerson").value,
        SpecialDeliveryListTemp.MobileNo = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("MobileNo").value,
        SpecialDeliveryListTemp.EmailID = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("EmailID").value,
        SpecialDeliveryListTemp.Address = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("Address").value,
        SpecialDeliveryListTemp.pincode = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("PinCode").value,


        SpecialDeliveryListTemp.Taluk = TalukName,
        SpecialDeliveryListTemp.Floortypecode = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("Floor").value,
        SpecialDeliveryListTemp.Floortype = FloortypeName;
      //SpecialDeliveryListTemp.PincodeLocation ="123";
      SpecialDeliveryListTemp.PincodeLocation = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("PincodeLocation").value;
      this.SpecialDeliveryList.push(SpecialDeliveryListTemp);
      this._ServiceLocationAndOperation_SpecialDelivery_Form.reset();
      this._SLSpecialDeliverysubmitted = false;
      // }
    }
  }
  SignoffDocumentSelect(event, document) {
    // this._TempLastAddedDocumentinCustomer = null
    this._TempLastAddedDocumentinCustomer = event.currentFiles[0]
    // alert(this._TempLastAddedDocumentinCustomer.size)
    if (this._TempLastAddedDocumentinCustomer.size > 3000000) {
      this._submittedimage = true
      this._CustomExceptionService.handleWarning("Your File size does not exceed 3 MB")
      document.clear();
      return
    }
    this._LastAddedDocumentsignoff = event.currentFiles[0];
    this._submittedimage = false
    document.clear();
     this.disabledate = true
    //this._Signoffform.controls["cutoffdateforsignedcontract"].reset()

  }
  onDocumentClear() {
    // this.employeeimage = null;
    this._LastAddedDocumentsignoff = null;
     this.disabledate = false
  }
  formconverstionSignoff(signoffdocuments: File[]) {
    let time = new Date();
    const formData: FormData = new FormData();
    //TimeStamp Add:


    for (var x in signoffdocuments) {
      if (signoffdocuments[x] != undefined) {
        //var index = p_documentdetails.findIndex(obj => obj.attachmentname == documents[x].name);
        //console.log("Index", index);
        //if (index != -1) {
        var NewFileName = signoffdocuments[x].name || "";
        // p_documentdetails[index].attachmentname = NewFileName;
        // p_documentdetails[index].attachmenturl = NewFileName;
        formData.append('iFormFile', signoffdocuments[x], NewFileName);
      }
    }
    this._SignOffOBJ = {
      "CustomerSiteSignoff": this._PrequoteSignoff, "SpecialDelivery": this.SpecialDeliveryList || []
    };
    var _CustomersiteFD = JSON.stringify(this._SignOffOBJ);
    formData.append('strCustomerSite', _CustomersiteFD);
    return (formData);

  }
  GetInvoiceConfigurations(event){
    // alert(event);
    var lrcopy = event
    if(lrcopy == "MSC00011"){
      this.disableInvoice = false
    }else{
      this.disableInvoice = true
    }
  }
  onSavesignoff() {
    this._submitted = true
    var IsSpecialDelivery = this._Signoffform.controls['isspecialdelivery'].value
    if( IsSpecialDelivery== "MSC00011" && this.SpecialDeliveryList.length == 0){
      this._CustomExceptionService.handleWarning("Please Add special delivery");
      return;
    }
    if (this._Signoffform.valid && this._CustomerContactInvoiceform.valid || this._CustomerContactOutgoingform.valid) {


      this._PrequoteSignoff = this._Signoffform.value
      this._PrequoteSignoff.customersitecode = this.customersiteCode
      this._PrequoteSignoff.customercode = this.customerCode
      this._PrequoteSignoff.lstCustomerSiteAddress = []
      this._PrequoteSignoff.lstCustomerSiteContact = []
      // this._PrequoteSignoff.createdon =new Date()
      // this._PrequoteSignoff.modifiedon =new Date()
      this._PrequoteSignoff.createdby = "ADMIN"
      this._PrequoteSignoff.modifiedby = "ADMIN"
      this._PrequoteSignoff.prequotesignedoffby = "ADMIN"
      var l_CustomerContactInvoice = new CustomerSiteContact();
      l_CustomerContactInvoice.contactid = 0;
      l_CustomerContactInvoice.customersitecode = "";
      l_CustomerContactInvoice.contacttypecode = "PQT00035";
      l_CustomerContactInvoice.contactperson = this._CustomerContactInvoiceform.get("contactperson").value;
      l_CustomerContactInvoice.designation = this._CustomerContactInvoiceform.get("designation").value;
      l_CustomerContactInvoice.department = this._CustomerContactInvoiceform.get("department").value;
      l_CustomerContactInvoice.phoneno = this._CustomerContactInvoiceform.get("phoneno").value;
      l_CustomerContactInvoice.mobileno = this._CustomerContactInvoiceform.get("mobileno").value;
      l_CustomerContactInvoice.emailid = this._CustomerContactInvoiceform.get("emailid").value;
      l_CustomerContactInvoice.faxno = this._CustomerContactInvoiceform.get("faxno").value;
      l_CustomerContactInvoice.recordstatuscode = "MSC00001";
      this._PrequoteSignoff.lstCustomerSiteContact.push(l_CustomerContactInvoice)
      var l_CustomerContactOutgoing = new CustomerSiteContact();
      l_CustomerContactOutgoing.contactid = 0;
      l_CustomerContactOutgoing.customersitecode = "";
      l_CustomerContactOutgoing.contacttypecode = "PQT00036";
      l_CustomerContactOutgoing.contactperson = this._CustomerContactOutgoingform.get("contactperson").value;
      l_CustomerContactOutgoing.designation = this._CustomerContactOutgoingform.get("designation").value;
      l_CustomerContactOutgoing.department = this._CustomerContactOutgoingform.get("department").value;
      l_CustomerContactOutgoing.phoneno = this._CustomerContactOutgoingform.get("phoneno").value;
      l_CustomerContactOutgoing.mobileno = this._CustomerContactOutgoingform.get("mobileno").value;
      l_CustomerContactOutgoing.emailid = this._CustomerContactOutgoingform.get("emailid").value;
      l_CustomerContactOutgoing.faxno = this._CustomerContactOutgoingform.get("faxno").value;

      l_CustomerContactOutgoing.recordstatuscode = "MSC00001";
      this._PrequoteSignoff.lstCustomerSiteContact.push(l_CustomerContactOutgoing)



      if (this._LastAddedDocumentsignoff == undefined || this._LastAddedDocumentsignoff == null) {
         this.disabledate = false
        this._PrequoteSignoff.signedcontractdocumentURL = ""

      } else {
        this._PrequoteSignoff.signedcontractdocumentURL = this._LastAddedDocumentsignoff.name || ""
      }
      // console.log("IN");
      this.CusomersignoffFile.push(this._LastAddedDocumentsignoff);
      // return

      // isspecialdelivery: ["MSC00012"]
    

      var CustomerSiteSignoff = this.formconverstionSignoff(this.CusomersignoffFile);
      this.onEd()
      this._PrequotesignoffService.PrequoteSignOff(CustomerSiteSignoff).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));
        // console.log("save", resutJSON)
        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          // this._CustomerSiteCode = resutJSON.customerSiteDetail.customersitecode
          // this.validationStatusCode = resutJSON.customerSiteDetail.gstValidationstatuscode
          this.Clearsignoff()
          // this._CustomExceptionService.handleSuccess(usererrors.Saved_Success_00);
          // window.location.reload();
          // this.ManageCustomersList = resutJSON.lstCustomer
          // this.reset()
          this.displaySuccessMSG = true;
        }
        else {
          this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }
      }, error => { this._CustomExceptionService.handleError(error) }
      );
    }
  }
  OpenSignOffImage() {
    // console.log("signimage", this._LastAddedDocumentsignoff)
    var signoffimage = URL.createObjectURL(this._LastAddedDocumentsignoff)
    window.open(signoffimage, "_blank");


  }
  Clearsignoff() {
    this._Signoffform.reset()
    this._Tempsignform.reset()
    this._LastAddedDocumentsignoff = null
  }
  onEd() {
    // alert("test");
    // ace.config.set("fontSize", "14px");
    // ace.config.set('basePath', 'https://unpkg.com/ace-builds@1.4.12/src-noconflict');
    // const aceEditor = ace.edit(this.editor.nativeElement);
    // aceEditor.getSession().setMode("ace/mode/json");
    // var myObj = this._SignOffOBJ;
    // var myJSON = JSON.stringify(myObj);
    // aceEditor.session.setValue(myJSON);
  }
  Ok()
  {
    this.displaySuccessMSG = false;
    window.location.reload();
  }
}
